import React from 'react';

import { DispatchItemInterface } from '../../../../interfaces/ServerInterfaces';
import DispatchWizard from './modalNewDispatch/DispatchWizard';

interface TransformToDispatchInterface {
  id: number
  despacho: DispatchItemInterface | null
  response: Function
  setTransformToDispatch: React.Dispatch<React.SetStateAction<boolean>>
  loading: boolean
}

export const TransformToDispatch = ({
  id,
  despacho,
  response,
  setTransformToDispatch,
  loading,
}: TransformToDispatchInterface) => {
  const onSubmitTransformToDispacth = (data: any) => {
    const payload = {
      mode: despacho?.mode,
      observations: !!data.observations
        ? data.observations
        : despacho?.observations,
      products: data.products,
      stockAreaFromId: despacho?.stockAreaTo?.id,
      stockAreaToId: despacho?.stockAreaFrom?.id,
    }

    response!(id!, 'DISPATCHED', despacho?.isPreDispatch!, payload, () =>
      setTransformToDispatch(false)
    )
  }

  return (
    <div className="flex w-full flex-col gap-3">
      <h2 className="mb-6 text-xl font-semibold">
        Transformar predespacho a despacho
      </h2>

      <DispatchWizard
        submitAction={onSubmitTransformToDispacth}
        loading={false}
        transformingToDispatch
        despacho={despacho!}
      />

      {/* <div className="self-end">
                <Button
                    color="slate-600"
                    textColor="white"
                    type="submit"
                    name="Aceptar"
                    action={onSubmitTransformToDispacth}
                />
            </div> */}
    </div>
  )
}
